import { Container } from '@/ui/design-system/Container'
import { Button } from '@/ui/components'

export function FinalCTA() {
  return (
    <section className="landing-topo relative overflow-hidden bg-landing-base py-24 lg:py-32">
      {/* Glow bloom behind the headline */}
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 h-[480px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-60"
        style={{ background: 'radial-gradient(closest-side, hsl(var(--landing-glow) / 0.14), transparent)' }}
        aria-hidden
      />
      <Container size="app">
        <div className="relative mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl md:text-5xl" style={{ textWrap: 'balance' }}>
            Ready to plan the next one?
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-white/65">
            Routes, crew, meals, gear, and weather in one workspace, shared on your terms.
          </p>
          <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">
            <Button size="lg" asChild className="shadow-glow">
              <a href="/signup">Start planning free</a>
            </Button>
            <Button
              variant="outline"
              size="lg"
              asChild
              className="border-white/25 bg-transparent text-white hover:bg-white/10 hover:text-white"
            >
              <a href="/join">Join an existing trip</a>
            </Button>
          </div>
        </div>
      </Container>
    </section>
  )
}
